export const CLEAR_ALL_ALERTS = 'CLEAR_ALL_ALERTS';
export const CLEAR_CUSTOMER_ALERTS = 'CLEAR_CUSTOMER_ALERTS';
export const CLEAR_DELETE_RESERVATION_ALERT = 'CLEAR_DELETE_RESERVATION_ALERT';

export function clearAlerts() {
  return { type: CLEAR_ALL_ALERTS };
}

export function clearCustomerAlerts() {
  return { type: CLEAR_CUSTOMER_ALERTS };
}

export function clearDeleteReservationAlert() {
  return { type: CLEAR_DELETE_RESERVATION_ALERT };
}



// WEBPACK FOOTER //
// ./src/actions/alertActions.js